import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PortalBuilderService {

  // imageUploadURL:any='https://api.fintrax.in/api/admin';
  constructor(private base_url:ApiUrlService, private http:HttpClient) { 
  }
  createAdminPortal(req: any): Observable<any> {
    const url = `${this.base_url.ADMIN_PORTAL_BUILDER}/buildPortal`;
    return this.http.post(url, req);
  }
  getAllAdminPortalWithPagination(paginationData:any): Observable<any> {
    const url = `${this.base_url.ADMIN_PORTAL_BUILDER}/get_with_paginate?limit=${paginationData.limit}&currentPage=${paginationData.currentPage}`;
    return this.http.get(url);
  }
  getAdminPortalBuilder(id:any): Observable<any> {
    const url = `${this.base_url.ADMIN_PORTAL_BUILDER}/get/${id}`;
    return this.http.get(url);
  }
  UpdateAdminPortal(req: any): Observable<any> {
    const url = `${this.base_url.ADMIN_PORTAL_BUILDER}/update/${req?.id}`;
    return this.http.put(url,req);
  }
  deleteAdminPortal(DistReq: string): Observable<any> {
    const url = `${this.base_url.ADMIN_PORTAL_BUILDER}/delete`;
    return this.http.post(url,DistReq);
  }

  // image Upload
  
  // uploadImage(fileData:any):Observable<any> {
  //   const url =`${this.imageUploadURL}/upload`;
  //   return this.http.post(url,fileData);
  // }

  fileUpload(type: any, folderName: any, image: any) {
    let headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');
    headers.set('Accept', "multipart/form-data");
    let params = new HttpParams();
    const formData: FormData = new FormData();
    formData.append('image', image);
    formData.append('folder_name', folderName);
    formData.append('type', type);
    return this.http.post(this.base_url.FILE_UPLOAD, formData, { params, headers })
  }

  //currency api cal 
  GetCurrency():Observable<any> {
    const url =`${this.base_url.BASE_CURRENCY}/get_with_paginate?limit=10000&currentPage=1`;
    return this.http.get(url);
  }
  
}
